var giphy_viewer_default = {
  "giphyWrapper": "C5QDB",
  "giphy_player": "nL-4u",
  "playIcon": "YmC8y",
  "gifRatio": "TlT-A"
};
export {
  giphy_viewer_default as default
};
//# sourceMappingURL=giphy-viewer-scss.js.map
